import ExpandButton from 'components/molecules/expand-button';
import {
  useState,
  type FC,
  type PropsWithChildren,
  type ReactNode,
  type KeyboardEvent,
} from 'react';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import { Avatar } from 'antd';

import s from './styles.module.scss';

interface CcmConsoleTableBlockProps extends PropsWithChildren {
  title: string;
  total: number;
  headerActions?: ReactNode;
}

const CcmConsoleTableBlock: FC<CcmConsoleTableBlockProps> = ({
  title,
  total,
  children,
  headerActions,
}) => {
  const [expanded, setExpanded] = useState(true);
  const dataCy = title.toLowerCase().split(' ').join('-');

  const toggleExpand = () => setExpanded(!expanded);
  const handleToggleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleExpand();
    }
  };

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s['title-group']}>
          <ExpandButton
            expanded={expanded}
            dataCy={dataCy}
            onClick={toggleExpand}
            className={s['expand-button']}
          />
          <div
            className={s['title-content']}
            role="button"
            tabIndex={0}
            onClick={toggleExpand}
            onKeyDown={handleToggleKeyDown}
          >
            <h3 className={s.title}>{title}</h3>
            <Avatar className={s.badge} size={20}>
              {total}
            </Avatar>
          </div>
        </div>
        {headerActions && (
          <div className={s['header-actions']}>{headerActions}</div>
        )}
      </div>
      <CollapseAnimation opened={expanded}>
        <div className={s.body}>{children}</div>
      </CollapseAnimation>
    </div>
  );
};
export default CcmConsoleTableBlock;
